// src/registered/site-admin/knowledge_base/KnowledgeBaseValidator.js
//
// Pure validator, same shape as the other SUSTINA validators and the
// precsion-med-react ComplianceDocumentValidator:  validate(input, ctx) -> { isValid, errors }
//
// Port of channels/validators/ComplianceDocumentValidator.js
// (F:\0000_CLOUD\PRECISION_MED\precsion-med-react).

import { DOCUMENT_TYPES } from "./KnowledgeBaseDTO";

const typeCodes = DOCUMENT_TYPES.map((t) => t.code);

/**
 * @param {object} doc            { knowledgeDocumentId?, name, documentTypeCode, effectiveDate, sourceKind, sourceUrl, body }
 * @param {object[]} existing     current documents in the corpus (for name-collision)
 * @param {string[]} [liveTypeCodes]  authoritative type codes from the Ref lookup, if loaded
 */
export const validateKnowledgeDocument = (doc = {}, existing = [], liveTypeCodes = null) => {
  const errors = {};
  const allowedTypes = Array.isArray(liveTypeCodes) && liveTypeCodes.length ? liveTypeCodes : typeCodes;
  const isUrl = doc.sourceKind === "url";
  const name = (doc.name || "").trim();

  if (!name) {
    // In URL mode the name may be derived from the fetched page — allow blank here.
    if (!isUrl) errors.name = "Document name is required.";
  } else if (
    existing.some(
      (d) =>
        d.knowledgeDocumentId !== doc.knowledgeDocumentId &&
        (d.name || "").trim().toLowerCase() === name.toLowerCase(),
    )
  ) {
    errors.name = "A document with this name already exists.";
  }

  if (!doc.documentTypeCode || !allowedTypes.includes(doc.documentTypeCode)) {
    errors.documentTypeCode = "Select a valid document type.";
  }

  if (!doc.effectiveDate) {
    errors.effectiveDate = "Effective date is required (needed for as-was queries).";
  } else if (Number.isNaN(Date.parse(doc.effectiveDate))) {
    errors.effectiveDate = "Effective date is not a valid date.";
  }

  if (isUrl) {
    if (!/^https?:\/\/\S+$/i.test((doc.sourceUrl || "").trim())) {
      errors.sourceUrl = "Enter a valid http(s) URL.";
    }
  } else if (!(doc.body || "").trim()) {
    errors.body = "Paste the document text.";
  }

  return { isValid: Object.keys(errors).length === 0, errors };
};
